import React from 'react';
import { Recipe } from '@/types/recipe';
import { Card, CardContent } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';
import RecipeImage from '@/components/recipe/RecipeImage';
import RecipeIcon from '@/components/common/RecipeIcon';

interface CompactRecipeCardProps {
  recipe: Recipe & {
    usageCount?: number;
    lastUsedDate?: string | null;
    daysSinceLastUse?: number | null;
  };
  onTagSelect?: (tag: string) => void;
}

const CompactRecipeCard: React.FC<CompactRecipeCardProps> = ({ recipe }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/recipe/${recipe.id}`);
  };

  return (
    <Card 
      className="border-golden-light bg-card shadow-sm hover:shadow-md transition-shadow duration-200 hover:border-sage/30 cursor-pointer overflow-hidden"
      onClick={handleClick}
    >
      <div className="relative">
        <RecipeImage 
          recipe={recipe}
          size="sm"
          compact={true}
          className="w-full rounded-none"
        />
        {recipe.isQuickRecipe && (
          <div className="absolute top-1 left-1 bg-emerald-100 rounded-full p-1">
            <RecipeIcon type="quick-recipe" size={8} className="text-emerald-700" />
          </div>
        )}
      </div>
      <div className="p-2">
        <h3 className="text-sm font-semibold text-charcoal line-clamp-2 leading-tight">
          {recipe.title}
        </h3>
      </div>
    </Card>
  );
};

export default CompactRecipeCard;